import { fetchWithSupabaseAuth } from "./supabaseClient.js";

function resolveErrorMessage(payload, fallbackMessage) {
  if (typeof payload?.detail === "string" && payload.detail.trim()) {
    return payload.detail.trim();
  }
  if (typeof payload?.detail?.message === "string" && payload.detail.message.trim()) {
    return payload.detail.message.trim();
  }
  if (Array.isArray(payload?.detail)) {
    const firstMessage = payload.detail.find((item) => typeof item?.msg === "string" && item.msg.trim())?.msg;
    if (firstMessage) {
      return firstMessage.trim();
    }
  }
  if (typeof payload?.message === "string" && payload.message.trim()) {
    return payload.message.trim();
  }
  return fallbackMessage;
}

async function requestJson(url, init, fallbackMessage) {
  const response = await fetchWithSupabaseAuth(url, init);
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(resolveErrorMessage(payload, fallbackMessage));
    error.status = response.status;
    error.code = payload?.detail?.code || payload?.code || "";
    throw error;
  }
  return payload;
}

function jsonRequest(method, payload) {
  return {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
}

export function fetchAutomationCatalog() {
  return requestJson("/api/automations/catalog", undefined, "Impossible de charger le catalogue d’automatisation.");
}

export function fetchAutomationTargets() {
  return requestJson("/api/automations/targets", undefined, "Impossible de charger les destinataires.");
}

export function fetchAutomations() {
  return requestJson("/api/automations", undefined, "Impossible de charger les tâches planifiées.");
}

export function fetchAutomation(taskId) {
  return requestJson(`/api/automations/${encodeURIComponent(taskId)}`, undefined, "Impossible de charger la tâche planifiée.");
}

export function createAutomation(payload) {
  return requestJson("/api/automations", jsonRequest("POST", payload), "Impossible de créer la tâche planifiée.");
}

export function updateAutomation(taskId, payload) {
  return requestJson(`/api/automations/${encodeURIComponent(taskId)}`, jsonRequest("PATCH", payload), "Impossible de modifier la tâche planifiée.");
}

export function deleteAutomation(taskId, expectedVersion) {
  return requestJson(
    `/api/automations/${encodeURIComponent(taskId)}`,
    jsonRequest("DELETE", { expected_version: expectedVersion }),
    "Impossible de supprimer la tâche planifiée.",
  );
}

export function previewAutomation(payload) {
  return requestJson("/api/automations/preview", jsonRequest("POST", payload), "Impossible de prévisualiser cette automatisation.");
}

export function applyAutomationOperation(taskId, operation, expectedVersion) {
  return requestJson(
    `/api/automations/${encodeURIComponent(taskId)}/${encodeURIComponent(operation)}`,
    jsonRequest("POST", { expected_version: expectedVersion }),
    "Impossible de modifier l’état de la tâche.",
  );
}

export function runAutomationNow(taskId) {
  return requestJson(`/api/automations/${encodeURIComponent(taskId)}/run`, { method: "POST" }, "Impossible de démarrer la tâche maintenant.");
}

export function fetchAutomationRuns(taskId, { limit = 100 } = {}) {
  return requestJson(`/api/automations/${encodeURIComponent(taskId)}/runs?limit=${encodeURIComponent(limit)}`, undefined, "Impossible de charger l’historique d’exécution.");
}

export function fetchAutomationCalendar(start, end) {
  const searchParams = new URLSearchParams({ start, end });
  return requestJson(`/api/automations/calendar?${searchParams.toString()}`, undefined, "Impossible de charger le calendrier.");
}

export function fetchAutomationHealth() {
  return requestJson("/api/automations/health", undefined, "Impossible de vérifier le moteur de planification.");
}

export function fetchMyNotifications({ unreadOnly = false, limit = 50, signal } = {}) {
  const searchParams = new URLSearchParams({
    unread_only: unreadOnly ? "true" : "false",
    limit: String(limit),
  });
  return requestJson(`/api/me/notifications?${searchParams.toString()}`, { signal }, "Impossible de charger les notifications.");
}

export function markNotificationsSeen(notificationIds) {
  return requestJson("/api/me/notifications/seen", jsonRequest("POST", { notification_ids: notificationIds }), "Impossible de confirmer l’affichage des notifications.");
}

export function updateNotificationRead(notificationId, read = true) {
  return requestJson(`/api/me/notifications/${encodeURIComponent(notificationId)}`, jsonRequest("PATCH", { read }), "Impossible de mettre à jour la notification.");
}

export function markAllNotificationsRead({ authAccessToken, signal } = {}) {
	return requestJson(
		"/api/me/notifications/read-all",
		{ method: "POST", authAccessToken, signal },
		"Impossible de marquer les notifications comme lues.",
	);
}
